import { EntityType } from '@frontend/common';
import { ConstraintClient } from '@frontend/constraint/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';

declare global {
    interface WindowEventMap {
        'useConstraint:request': CustomEvent<string>;
    }
}

const REQUEST_CONSTRAINT_EVENT = 'useConstraint:request';
const STORAGE_KEY = 'CSTRS_REQ';

export function constraintRequest(constraintId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_CONSTRAINT_EVENT, { detail: constraintId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

/** Seeds resolved constraints into the shared resolve store. Required for reactive constraint details. */
export function ConstraintResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_CONSTRAINT_EVENT, EntityType.CONSTRAINT, (ids) => ConstraintClient.resolveConstraints(ids), props.dispatch);
    return null;
}
